import React from "react";

import { IconProps } from "../types";

import { Path } from "./Path";

export const Plus = ({ className, color }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={className}
    fill={color}
  >
    <path d="M19 13.4512H13V19.4512H11V13.4512H5V11.4512H11V5.45117H13V11.4512H19V13.4512Z" />
  </svg>
);
